import Vue from 'vue'
import axios from 'axios'

// state
export const state = {
  scoreCounts: {},
  isScoreCountsLoading: true,
  scorePlayers: {},
  isScorePlayersLoading: {},
}

// getters
export const getters = {
  getScoreCountsByRoundId: ({ scoreCounts }) => ({ roundId }) => scoreCounts[roundId] || [],
  getScorePlayers: ({ scorePlayers }) => ({ roundId, score }) => {
    if (scorePlayers[roundId] && scorePlayers[roundId][score]) {
      return scorePlayers[roundId][score]
    }
    return []
  },
  isScorePlayersLoading: ({ isScorePlayersLoading }) => (score) => isScorePlayersLoading[score] || false,
}
// mutations
export const mutations = {
  fetchScoreCountsStart(state) {
    state.isScoreCountsLoading = true
  },
  fetchScoreCountsSuccess(state, { roundId, scoreCounts, round }) {
    let maxScoreCount = 8
    try {
      if (round.season.league.type === 1) {
        maxScoreCount = 2
      }
    } catch (error) {}
    const counts = Array.from(Array(maxScoreCount).keys()).sort((a, b) => b - a).map((id) => {
      const currentPosition = Math.abs(id - maxScoreCount)
      const position = scoreCounts.find(({ score, numOfPlayers }) => ((id + 1) === score))
      if (position) {
        return {
          ...position,
          position: currentPosition,
        }
      }
      return {
        position: currentPosition,
        score: id + 1,
        numOfPlayers: 0,
        isMyPosition: false,
      }
    })
    Vue.set(state.scoreCounts, roundId, counts || [])
    state.isScoreCountsLoading = false
  },
  fetchScoreCountsFailed(state) {
    state.isScoreCountsLoading = false
  },
  fetchPlayersWithScoreStart(state, { score }) {
    Vue.set(state.isScorePlayersLoading, score, true)
  },
  fetchPlayersWithScoreSuccess(state, { roundId, score, players: { data } }) {
    let players = state.scorePlayers[roundId] || []
    players[score] = data
    Vue.set(state.scorePlayers, roundId, players)
    Vue.set(state.isScorePlayersLoading, score, false)
  },
  fetchPlayersWithScoreFailed(state, { score }) {
    Vue.set(state.isScorePlayersLoading, score, false)
  },
}
// actions
export const actions = {
  async fetchScoreCounts({ commit, rootGetters }, { roundId } = {}) {
    let scoreCounts = null
    try {
      commit('fetchScoreCountsStart')
      scoreCounts = await axios.get(`round/${roundId}/scoreCounts`)
      commit('fetchScoreCountsSuccess', {
        roundId,
        scoreCounts,
        round: rootGetters['rounds/index/getRoundById'](roundId),
      })
    } catch (e) {
      commit('fetchScoreCountsFailed')
    }
    return scoreCounts
  },
  async fetchPlayersWithScore({ commit }, { roundId, score } = {}) {
    let response = null
    try {
      commit('fetchPlayersWithScoreStart', { score })
      response = await axios.get(`round/${roundId}/rankedPlayers/${score}`)
      commit('fetchPlayersWithScoreSuccess', { roundId, score, players: response.users })
    } catch (e) {
      commit('fetchPlayersWithScoreFailed', { score })
    }
    return response
  },
}
